import type {
  EstimationItemResponse,
  UpdateEstimationItemRequest,
} from '@/api/schema/data-contracts';
import { ApiEstimationItemStatus } from '@/api/schema/data-contracts';
import { sortExpressions } from '@/utils/sorting';

import type { EstimationItemsFormModelRow } from '../model';

export const mapFromEstimationItemResponse = (
  estimationItemResponse: EstimationItemResponse,
): UpdateEstimationItemRequest => ({
  name: estimationItemResponse.name,
  description: estimationItemResponse.description,
  isEnabled: estimationItemResponse.isEnabled,
  status: estimationItemResponse.status,
  isParentBasedCalculation: estimationItemResponse.isParentBasedCalculation,
  unit: estimationItemResponse.unit,
  currencyId: estimationItemResponse.currencyId,
  methodologyId: estimationItemResponse.methodologyId,
  parameterValues: estimationItemResponse.parameters
    .sort(sortExpressions.byOrder)
    .map((parameter) => parameter.value ?? null),
  estimationModelGroupId: estimationItemResponse.estimationModelGroupId,
  omitReason: estimationItemResponse.omitReason,
  parentId: estimationItemResponse.parentId,
  phaseLeadId: estimationItemResponse.phaseLeadId,
});

export const mergeResponseWithFormModelUpdates = (
  responseEstimationItem: EstimationItemResponse,
  formModelItemToUpdate: EstimationItemsFormModelRow,
): UpdateEstimationItemRequest => {
  const estimationItemUpdatePayload = mapFromEstimationItemResponse(responseEstimationItem);
  if (!formModelItemToUpdate.isIncluded) {
    estimationItemUpdatePayload.status = 'OMITTED';
  } else {
    if (estimationItemUpdatePayload.status === ApiEstimationItemStatus.OMITTED) {
      estimationItemUpdatePayload.status = 'ESTIMATED';
    }
  }
  estimationItemUpdatePayload.omitReason = formModelItemToUpdate.omitReason;
  estimationItemUpdatePayload.methodologyId = formModelItemToUpdate.methodologyId;
  estimationItemUpdatePayload.parameterValues = formModelItemToUpdate.parameters
    // We have to filter out parameters that have no parameterName as there's a hard to simulate bug
    // related to react-hook-form that during form reset if size of parameters collection changes to smaller,
    // some stale incomplete items might stay there.
    .filter((x) => !!x.parameterName)
    .map((x) => x.value);
  return estimationItemUpdatePayload;
};
